import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import Editor from './Editor';

export default createTaskType({
    id: 'productive_writing',
	label: 'Productive Writing',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    backgroundImages: { count: 1 },

    editor: Editor,
    createItemsTemplate: () => [
        ...times(1, createItem)
    ],

    convertToLocalFormat(task) {
      task = cloneDeep(task);
      task.original_items = cloneDeep(task.items); // for later reuse in upload
      const exampleItem = task.items.find(item => item.is_example);
      task.items = [exampleItem];

      return task;
    },

    convertToUploadFormat(task, { isNew }) {
      task = cloneDeep(task);

      if (isNew) {
        task.background_image_2 = null;
      } else {
        delete task.background_image_2;
      }

      const exampleItem = task.items[0]
      const normalItem = cloneDeep(exampleItem);
      normalItem.is_example = false;

      if (task.original_items?.length === 2) {
        const existingNormal = task.original_items.find(i => !i.is_example);
        if (existingNormal?.item_id) {
          normalItem.item_id = existingNormal.item_id;

          normalItem.answers = normalItem.answers.map((answer, idx) => {
            if (existingNormal.answers[idx]?.answer_id) {
              answer.answer_id = existingNormal.answers[idx].answer_id;
            }
            return answer;
          });
        }
      }
      task.items = [exampleItem, normalItem];

      task.items = task.items.map(item => ({
        ...item,
        answers: item.answers.map(answer => {
          if (typeof answer.description === 'string') {
            // Preserve the full description as a single string in an array
            answer.description = [answer.description];
          }
          return answer;
        })
      }));

      return task;
    },

    getKeys: (item) => {
        return item.answers.filter(x => x.is_correct_answer).map(x => x.key.join(', '));
    }
});

function createItem(index) {
    return {
        is_example: index === 0,
        is_capital: false,
        ...(index === 0 && { rubric_id: '' }),
        answers: times(3, () => ({
            is_correct_answer: true,  // backend required a value to be set.
            image_id: '',
            description: []
        })),
    }
}